module.exports = __webpack_public_path__ + "static/media/34@2x.918df52d.png";